import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Applications/InteractiveSearch/InteractiveSearch.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Applications/InteractiveSearch/InteractiveSearch.ts';

export const prototypeName = 'Z56zdbKLyjSon5OA7R89frP44wvoLks8leG6N7DPsvzPzpkZK3HVAlznwzjJuWLPkjJkXAtq1AX3njWwHNN';
export {styles};
export {script};